var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-menu",
    {
      ref: _vm.id,
      attrs: {
        id: _vm.id,
        "data-cy": _vm.dataCy,
        value: _vm.value,
        disabled: _vm.disabled,
        "return-value": _vm.returnValue,
        "close-on-content-click": _vm.closeOnContentClick,
        "open-on-click": _vm.openOnClick,
        "max-height": _vm.maxHeight,
        "min-width": _vm.minWidth,
        "nudge-right": _vm.nudgeRight,
        "nudge-left": _vm.nudgeLeft,
        "nudge-top": _vm.nudgeTop,
        "nudge-bottom": _vm.nudgeBottom,
        "offset-x": _vm.offsetX,
        "offset-y": _vm.offsetY,
        "z-index": _vm.zIndex,
        "position-x": _vm.positionX,
        "position-y": _vm.positionY,
        attach: _vm.attach,
        rounded: _vm.rounded,
        left: _vm.left,
        icon: _vm.icon,
        "content-class": _vm.contentClass,
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on, attrs }) {
            return [
              _c(
                "v-btn",
                _vm._g(
                  _vm._b(
                    {
                      attrs: { id: `menu-${_vm.id}`, icon: "", color: "black" },
                    },
                    "v-btn",
                    attrs,
                    false
                  ),
                  on
                ),
                [
                  _c("v-icon", { attrs: { color: _vm.color } }, [
                    _vm._v(_vm._s(_vm.icon)),
                  ]),
                ],
                1
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.toggleMenu,
        callback: function ($$v) {
          _vm.toggleMenu = $$v
        },
        expression: "toggleMenu",
      },
    },
    [_vm._v(" "), _vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }